import React from 'react';
export function Footer() {
  return <footer className="w-full bg-zinc-950 py-10" data-id="element-46" data-mp="32wd2qgad7ltj">
      <div className="mx-auto flex max-w-6xl flex-col gap-2 px-6 text-sm text-zinc-500 sm:flex-row sm:items-center sm:justify-between" data-id="element-47" data-mp="3gfsmebmgesmg">
        <p className="font-display text-base uppercase tracking-wide text-zinc-300" data-id="element-48" data-mp="32p5qer82vgu2">Boxeo 360</p>
        <p data-id="element-49" data-mp="36q94b86kf2sn">© {new Date().getFullYear()} Boxeo 360. Material digital para profesores de boxeo.</p>
      </div>
    </footer>;
}